import { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { FaUserCircle } from "react-icons/fa";
import { AgentPinChatsListApi } from "../../../Api";

export default function NumberList({
  search,
  openChat,
  handleClick,
  CampaignID,
  AgentID,
}: {
  search: string;
  openChat: string;
  handleClick: (v: string) => void;
  CampaignID: number;
  AgentID: number;
}) {
  const [ListNumbers, setListNumbers] = useState<{ number: string }[]>([]);
  const [page, setPage] = useState(1);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isSearchedCall, setIsSearchCall] = useState(false);
  const [totalPage, setTotalPage] = useState(0);

  const GetListNumber = useQuery({
    queryKey: [
      "Agent_Pin_Chat_List",
      {
        search,
        is_pagination: true,
        page,
        campaign_id: CampaignID,
        agent_id: AgentID,
      },
    ],
    queryFn: AgentPinChatsListApi,
    onSuccess: (resp: AxiosResponse) => {
      setIsSearchCall(false);
      setIsFirstLoad(false);
      let array = isSearchedCall
        ? resp.data?.Numbers || []
        : [...ListNumbers, ...(resp.data?.Numbers || [])];
      setListNumbers(
        array.reduce((accumulator: any, currentValue: any) => {
          if (
            !accumulator.find(
              (item: any) => currentValue.number === item.number
            )
          ) {
            accumulator.push(currentValue);
          }
          return accumulator;
        }, [])
      );
      setPage(resp.data?.info?.current_page);
      setTotalPage(resp.data?.info?.total_page);
    },
    enabled: false,
  });

  useEffect(() => {
    GetListNumber.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    setListNumbers([]);
    GetListNumber.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CampaignID, AgentID]);

  useEffect(() => {
    if (isFirstLoad) return;
    const handler = setTimeout(() => {
      setIsSearchCall(true);
      GetListNumber.refetch();
    }, 300);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  if (!GetListNumber.isFetching && ListNumbers.length === 0)
    return (
      <ul className="list-unstyled d-flex flex-column gap-3 px-3 pt-3">
        <li className="d-flex gap-2 align-items-center p-3 d-flex justify-content-center fw-bold text-secondary">
          No Numbers Found
        </li>
      </ul>
    );

  return (
    <ul className="list-unstyled d-flex flex-column gap-3 px-3 pt-3">
      {ListNumbers.map((item, i) => (
        <li
          onClick={() => handleClick(item?.number)}
          key={i}
          className={`d-flex gap-2 align-items-center p-xl-3 p-2 shadow-sm rounded-3 cursor-pointer ${
            openChat === item?.number ? "bg-olive" : "bg-white"
          }`}
        >
          <FaUserCircle style={{ height: 34, width: 34 }} />
          <div className="px-2">
            <p className="fw-semibold h6 mb-0">{item.number}</p>
          </div>
        </li>
      ))}
      {totalPage > page ? (
        <li className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={() => setPage(page + 1)}>
            Load more
          </button>
        </li>
      ) : null}
    </ul>
  );
}
